const stampBgm = {
  beforeCreate() {
    this.$bgm = window.CloudzetAudio;
  },
  data: () => ({
    playingAnalyzing: null,
  }),
  methods: {
    playPositive() {
      this.$bgm.play('positive');
    },
    playNegative() {
      this.$bgm.play('negative');
    },
    playScanning() {
      this.$bgm.play('scanning');
    },
    playAnalyzing() {
      this.playingAnalyzing = this.$bgm.play('analyzing');
      this.$bgm.once(
        'end',
        () => {
          this.playingAnalyzing = null;
        },
        this.playingAnalyzing
      );
    },
    stopAnalyzing() {
      if (typeof this.playingAnalyzing !== 'number') return;

      this.$bgm.stop(this.playingAnalyzing);
    },
    playCountDown() {
      this.$bgm.play('countdown');
    },
    playCountDownLast() {
      this.$bgm.play('last_countdown');
    },
  },
};

export default stampBgm;
